import { initReactI18next } from 'react-i18next'
import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import moment from 'moment'
import 'moment/locale/pt-br'
import 'moment/locale/es'
import 'moment/locale/en-gb'

import { getLocale } from './locale'
import resources from './resources'

const detectedLocale = getLocale(true)

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    defaultNS: 'common',
    lng: detectedLocale,
    fallbackLng: 'pt',
    detection: {
      order: ['navigator'],
    },

    react: {
      useSuspense: false
    },

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  })

const momentLocale = detectedLocale === 'pt' ? 'pt-br' : detectedLocale === 'es' ? 'es' : 'en-gb'
moment.locale(momentLocale, { week: { dow: 1 } })

export default i18n
